import React from 'react'
import { useHistory } from 'react-router';
import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { ButtonAsistencia, Titulo } from 'app-principal-componentes-visuales'
import './TipoFormulario.scss';

const TipoFormulario = ({pathDomicilio, pathBarrioCerrado, propsDomicilio = null, propsBarrioCerrado = null}) => {
    const history = useHistory();
    
    const onHandleAgregarDireccion = () => history.replace(pathDomicilio, propsDomicilio);
    const onHandleAgregarBarrioCerrado = () => history.replace(pathBarrioCerrado, propsBarrioCerrado);

    return (
        <IonGrid>
            <IonRow className='tipo-formulario-modal'>
                <IonCol size='12'>
                    <Titulo
                        
                        id="titulo-tipo-formulario-modal" 
                        className='titulo-tipo-formulario-modal'
                        titulo='¿El domicilio se encuentra en un barrio cerrado o country?'
                    />
                </IonCol>
                <IonCol size='12'>
                    <ButtonAsistencia 
                        id='seleccionar-socio'
                        className='button-tipo-formulario-modal' 
                        onClick={onHandleAgregarBarrioCerrado}
                        titulo={'Sí'}
                        arrow
                    />
                </IonCol>
                <IonCol size='12'>
                    <ButtonAsistencia 
                        id='seleccionar-socio'
                        className='button-tipo-formulario-modal' 
                        onClick={onHandleAgregarDireccion}
                        titulo={'No'}
                        arrow
                    />
                </IonCol>
            </IonRow>
        </IonGrid>
    )
}

export default TipoFormulario
